"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var variables = {
    shadow: "#818181",
    main: {
        borderRadius: "3px",
        borderRadiusLg: "6px",
        linkFontWeight: 500
    },
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
    },
    spacing: {
        "0": "0",
        "1": "0.25rem",
        "2": "0.5rem",
        "3": "1rem",
        "4": "1.5rem",
        "5": "3rem",
        "6": "4rem"
    },
    fonts: {
        heading: '"Rubik", Arial, Helvetica, sans-serif',
        sansSerif: '"Roboto", Arial, Helvetica, sans-serif'
    }
};
exports.default = variables;
//# sourceMappingURL=index.js.map